import React from "react";
import clsx from "clsx";

const ImageThumbnail: React.FC<{
  srcPath: string;
  title: string;
  placeholderImageStyle: object;
  onClick?: () => void;
}> = ({ srcPath, title, placeholderImageStyle, onClick = () => null }) => (
  <>
    <img
      src={srcPath}
      alt={""}
      style={placeholderImageStyle}
      onClick={onClick}
    />
    <div
      data-testid="rlcs-screenshots-btn-text-view"
      className="rl-cloud-sandbox__screenshots-text"
    >
      {title}
    </div>
  </>
);
const ErrorThumbnail: React.FC<{ title: string }> = ({ title }) => (
  <div
    data-testid="rlcs-screenshots-btn-text-check"
    className="rl-cloud-sandbox__screenshots-nodata"
  >
    {title}
  </div>
);

const ViewScreenshotThumbnail: React.FC<{
  thumbnailTitle: string;
  errorTitle: string;
  srcPath: string;
  className?: string;
  placeholderImageStyle?: object;
  onClick?: () => void;
}> = ({
  thumbnailTitle,
  errorTitle,
  srcPath,
  className,
  placeholderImageStyle = {},
  onClick
}) => (
  <div
    className={`rl-cloud-sandbox__summary-screenshots-thumb-container ${className}`}
    data-testid="rlcs-screenshots-btn"
    onClick={onClick}
  >
    <div
      className={clsx(
        "rl-cloud-sandbox__summary-screenshots-thumb",
        srcPath && "rl-cloud-sandbox__summary-screenshots-thumb--clickable"
      )}
    >
      {srcPath ? (
        <ImageThumbnail
          title={thumbnailTitle}
          srcPath={srcPath}
          placeholderImageStyle={placeholderImageStyle}
        />
      ) : (
        <ErrorThumbnail title={errorTitle} />
      )}
    </div>
  </div>
);

export default ViewScreenshotThumbnail;
